/* Moulin de l'Aunay — logique des offres (chargé une fois via theme.liquid).
 * Deux responsabilités, une seule source de vérité (/cart.js) :
 *   1) CODE AVANTAGE — appliquer / retirer / remplacer un code + indication « code actif ».
 *      Markup : snippets/ma-code-avantage.liquid + ma-code-avantage-bandeau.liquid.
 *   2) FILTRE CADEAU — n'afficher, dans le picker du panier, que les 4 cadeaux de
 *      l'opération du code actif. Markup : snippets/cart-gift-picker.liquid.
 * Tout le comportement vit ICI (délégation d'événements) pour survivre au ré-rendu du
 * panier/drawer par le section-rendering de Shopify, où les <script> inline ne tournent pas. */
(function () {
  'use strict';

  // Opération = 2e lettre du code (I=R9, J=R10 ; F/G/H = R6/R7/R8, clôturées 2026-09-11).
  // Valeurs = SKU/réf des 4 cadeaux de l'opération.
  // >>> À COMPLÉTER À CHAQUE NOUVELLE OPÉRATION (nouvelle lettre). <<<
  var GIFT_MAP = {
    I: ['SWARO', 'MACNB', 'N589', 'PATA'],
    J: ['NAPPE', 'G140', 'FENO', 'LAX']
  };

  // Opérations SANS offre à 5 € : tous leurs codes sont des lots (type 1), y compris ceux
  // dont le suffixe est >= 50 (R10-26 : QJP50, QJP60, QJP70, QJP75). Voir isType2().
  var LOTS_ONLY_OPS = ['J'];

  // Opérations DÉDIÉES à un produit : leur code ne suit pas le format historique, donc la
  // 2e lettre ne désigne aucune opération -> on les indexe par le CODE ENTIER. Consulté
  // AVANT GIFT_MAP, ce qui évite aussi qu'une future opération de la série R (lettre E…)
  // hérite par accident des cadeaux d'un code dédié.
  // Indexé par EMPREINTE du code (maFp, défini plus bas) et non par le code lui-même :
  // les valeurs de ce fichier sont servies publiquement, les commentaires non (Shopify
  // minifie l'asset). Calculer une empreinte : node ma-discount-app/scripts/fp.mjs MONCODE.
  // La cure Eau de Colon n'y figure pas : elle n'offre aucun cadeau (cures de 3, 6 ou 9
  // flacons depuis le 2026-09-10) et le picker est masqué pour elle (cart-gift-picker).
  var GIFT_MAP_BY_FP = {
    '976e9b42cf6312ec': ['SACISO', 'DIGES', 'FENO', 'SLIM'], // Eau de Colon −35 % (clôturée 2026-09-02)
    '57d18a0cb7d6aaea': ['JUM', 'PATN', 'PATA', 'SACISO']    // catalogue papier RB-26
  };

  // Code actif (MAJUSCULES). Source de vérité = /cart.js ; repli = mémoire locale.
  var currentCode = '';

  var UPDATE_URL = (window.Theme && Theme.routes && Theme.routes.cart_update_url) || '/cart/update.js';

  // Offre Type 2 (prix unique 5 €) : code d'OPÉRATION dont le suffixe numérique est >= 50
  // (ex. QFP75, QGP50, QHP95). Type 1 (lots) = suffixe < 50 (ex. QFP05) -> pas de plafond.
  // Le test de FORMAT est indispensable : type 2 = exclusif (applyCode vide le panier de ses
  // autres codes). Sans lui, un code NATIF finissant par >= 50 (ex. SOLDES50) serait pris pour
  // une offre 2 et supprimerait silencieusement l'opération en cours.
  var MAX_TYPE2 = 5; // unités max par référence pour l'offre à 5 €

  // Réfs EXCLUES de l'offre à 5 € : facturées au prix de lot habituel par la Function
  // « prix unique + cadeau », donc le plafond de 5 unités ne les concerne pas — ce serait
  // refuser une vente sur un produit qui n'est pas en promotion.
  // SOURCE DE VÉRITÉ DU PRIX = la balise Shopify `hors-offre-5e` posée sur la fiche produit
  // (lue par la Function). Cette liste-ci ne pilote QUE le plafond de quantité côté panier :
  // Liquid ne donne pas accès aux balises depuis /cart.js. À tenir à jour avec les balises.
  var NO_UNIT_PRICE_SKUS = ['SUED']; // Élixir du Suédois — décision client 2026-08-06
  // Mêmes produits, désignés par leur handle : c'est la seule prise qu'on ait sur une
  // ligne de PANIER, dont le DOM ne porte pas le SKU (il porte un lien /products/<handle>).
  var NO_UNIT_PRICE_HANDLES = ['sued'];

  function isExcludedFromType2(it) {
    var sku = (it && it.sku ? String(it.sku) : '').trim().toUpperCase();
    return !!sku && NO_UNIT_PRICE_SKUS.indexOf(sku) !== -1;
  }

  // Le sélecteur de quantité `el` porte-t-il sur un produit exclu ?
  // - Panier : on remonte à la ligne et on lit le handle du lien produit.
  // - Fiche produit : pas de ligne parente -> on lit le data-sku du bloc « cartes de lots ».
  function qtySelectorIsExcluded(el) {
    var row = el.closest('[data-line-index], .cart-item, li');
    if (row) {
      var link = row.querySelector('a[href*="/products/"]');
      if (link) {
        var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
        return !!m && NO_UNIT_PRICE_HANDLES.indexOf(m[1].toLowerCase()) !== -1;
      }
    }
    var box = document.querySelector('[data-sku]');
    var sku = box ? (box.getAttribute('data-sku') || '').trim().toUpperCase() : '';
    return !!sku && NO_UNIT_PRICE_SKUS.indexOf(sku) !== -1;
  }

  function isType2(code) {
    var up = (code || '').toUpperCase();
    if (!isValidCodeFormat(up)) return false; // un code natif n'est jamais une offre 2
    // Les codes dédiés sont des offres de type 1 (grille de lots) : leur suffixe est un
    // argument commercial (« −35 % »), pas le suffixe numérique du format d'opération.
    // Sans ce garde-fou, un futur code dédié en 50+ (ex. PROMO60) serait pris pour une
    // offre à 5 €, deviendrait exclusif et plafonnerait les quantités à 5.
    if (isSpecialCode(up)) return false;
    if (LOTS_ONLY_OPS.indexOf(up.charAt(1)) !== -1) return false;
    return parseInt(up.slice(-2), 10) >= 50;  // format garanti -> 2 derniers caractères = chiffres
  }

  // Format d'un code avantage MA : 2 lettres (préfixe Q/L + lettre d'opération) + P + 2 chiffres,
  // ex. QFP05, LGP10, QHP75. Seul garde-fou fiable contre les saisies quelconques : Shopify
  // enregistre et renvoie n'importe quel code inconnu (applicable:false), donc sa réponse ne
  // permet pas de distinguer une faute de frappe d'un vrai code Function pas encore applicable.
  // Codes d'opération DÉDIÉS à un produit, hors format historique (le nom porte l'offre).
  // Ils sont pilotés par une Discount Function au même titre que les codes d'opération, donc
  // ils doivent recevoir le MÊME traitement : acceptation optimiste (Shopify ne renvoie pas
  // `applicable:true` de façon fiable pour une remise Function -> traités en « natif », ils
  // seraient refusés à tort), révélation des cartes de lots, et contrôle par la liste
  // blanche. Toute entrée ajoutée ici doit donc AUSSI figurer dans
  // docs/Codes Operation MA.csv (sinon le code est rejeté).
  //
  // Les codes ne sont PLUS écrits en clair (2026-09-02) : ce fichier est servi publiquement
  // (/cdn/shop/t/<n>/assets/ma-offres.js), on y lisait les codes des opérations en cours.
  // On compare des EMPREINTES, comme la liste blanche assets/ma-codes.js.
  // Ajouter un code : node ma-discount-app/scripts/fp.mjs MONCODE, puis coller la valeur
  // ci-dessous en commentant l'OPÉRATION (jamais le code).
  // ⚠️ maFp() doit rester IDENTIQUE ici, dans layout/theme.liquid et dans fp.mjs. Le SHA-256
  // de la liste blanche ne convient pas ici : il est asynchrone dans le navigateur alors que
  // isValidCodeFormat() est appelé de façon synchrone un peu partout.
  function maFp(code) {
    var s = 'MA-fp-v1:' + String(code || '').toUpperCase();
    var h1 = 0x811c9dc5, h2 = 0x01000193;
    for (var i = 0; i < s.length; i++) {
      var c = s.charCodeAt(i);
      h1 = Math.imul((h1 ^ c) >>> 0, 0x01000193) >>> 0;
      h2 = Math.imul((h2 + c) >>> 0, 0x85ebca6b) >>> 0;
      h2 = (h2 ^ (h2 >>> 13)) >>> 0;
    }
    return ('0000000' + h1.toString(16)).slice(-8) + ('0000000' + h2.toString(16)).slice(-8);
  }
  var SPECIAL_CODE_FPS = [
    'bd799a2242793108', // cure Eau de Colon — cures 3/6/9 flacons, sans cadeau
    '976e9b42cf6312ec', // Eau de Colon −35 % — clôturée le 2026-09-02, entrée inerte
    '57d18a0cb7d6aaea'  // catalogue papier RB-26
  ];
  function isSpecialCode(code) { return SPECIAL_CODE_FPS.indexOf(maFp(code)) !== -1; }

  // Codes dont la remise Shopify REFUSE les remises de commande (« Combinaisons » →
  // « réductions de commande » décoché). Ils bloquent donc un code natif comme BIENVENUE10,
  // et doivent être nommés dans le message d'erreur plutôt que de laisser croire à une
  // faute de frappe. Les offres de TYPE 2 sont détectées automatiquement (isType2) ; cette
  // liste ne sert qu'aux codes hors format, dont le réglage ne se déduit pas du nom.
  //
  // ⚠️ À TENIR À JOUR AVEC L'ADMIN : c'est une recopie d'un réglage Shopify que le thème ne
  // peut pas lire. L'Eau de Colon −35 % y est entrée le 2026-08-18, quand le cumul avec les
  // remises de commande a été retiré côté admin ; la cure Eau de Colon le 2026-08-31, créée
  // d'emblée sans cumul de commande (combinesWith.orderDiscounts = false). Si le cumul était
  // rouvert, retirer l'empreinte d'ici — sinon le site accuserait une offre qui ne bloque
  // plus rien. Empreintes, mêmes règles que SPECIAL_CODE_FPS ci-dessus.
  var NO_ORDER_CUMUL_FPS = [
    'bd799a2242793108', // cure Eau de Colon — cures 3/6/9 flacons, sans cadeau
    '976e9b42cf6312ec'  // Eau de Colon −35 % — clôturée le 2026-09-02, entrée inerte
  ];

  function isValidCodeFormat(code) {
    var up = (code || '').toUpperCase();
    if (isSpecialCode(up)) return true;
    return /^[QL][A-Z]P\d{2}$/.test(up);
  }
  // Sel partagé avec ma-discount-app/scripts/gen-whitelist.mjs (const SALT) — DOIT être
  // identique des deux côtés, sinon les empreintes ne correspondent plus (tous les codes
  // seraient rejetés).
  var MA_CODE_SALT = 'MA-codes-v1:';
  function sha256Hex(str) {
    return crypto.subtle.digest('SHA-256', new TextEncoder().encode(str)).then(function (buf) {
      var a = new Uint8Array(buf), h = '';
      for (var i = 0; i < a.length; i++) h += a[i].toString(16).padStart(2, '0');
      return h;
    });
  }
  // LISTE BLANCHE (assets/ma-codes.js -> window.MA_ACTIVE_CODES) : EMPREINTES SHA-256 des codes
  // actifs — jamais les codes en clair, donc le site n'expose aucun code. Un code au format
  // opération n'est « connu » que si l'empreinte de (SALT+code) figure dans la liste.
  // Renvoie une PROMISE<bool>. Replis SÛRS -> permissif (on ne bloque jamais tout le monde) :
  //  - liste absente/vide (asset non chargé) : on retombe sur le format seul ;
  //  - crypto.subtle indisponible (contexte non sécurisé) : on accepte.
  // Ne concerne PAS les codes natifs (hors format, validés par Shopify).
  function isKnownOpCode(code) {
    var up = (code || '').toUpperCase();
    var list = window.MA_ACTIVE_CODES;
    if (!Array.isArray(list) || !list.length) return Promise.resolve(isValidCodeFormat(up));
    if (!isValidCodeFormat(up)) return Promise.resolve(false);
    if (!(window.crypto && crypto.subtle)) return Promise.resolve(true);
    return sha256Hex(MA_CODE_SALT + up).then(function (h) { return list.indexOf(h) !== -1; });
  }
  function isGiftItem(it) {
    return !!(it && it.properties && String(it.properties._gift).toLowerCase() === 'true');
  }

  // ---------------------------------------------------------------------------
  // Mémoire locale (partagée avec le bloc « cartes de lots » : clés ma_code_active / ma_code_value)
  // ---------------------------------------------------------------------------
  function fromLocal() {
    try { return (localStorage.getItem('ma_code_value') || '').toUpperCase(); } catch (e) { return ''; }
  }
  function storeCode(code) {
    try { localStorage.setItem('ma_code_active', '1'); localStorage.setItem('ma_code_value', code); } catch (e) {}
  }
  function forgetCode() {
    try { localStorage.removeItem('ma_code_active'); localStorage.removeItem('ma_code_value'); } catch (e) {}
  }
  function fromDom() {
    var el = document.querySelector('[data-ma-gift][data-active-code]');
    var c = el && el.getAttribute('data-active-code');
    return c ? c.toUpperCase() : '';
  }

  // ---------------------------------------------------------------------------
  // FILTRE CADEAU
  // ---------------------------------------------------------------------------
  function applyGiftFilter() {
    var pickers = document.querySelectorAll('.cart-gift');
    if (!pickers.length) return; // picker absent -> rien à faire (appel bon marché)
    // Cadeaux autorisés pour le code d'OPÉRATION actif (un code natif comme BIENVENUE10 ne
    // devient jamais currentCode). Deux indexations, dans cet ordre :
    //  1. code ENTIER, pour les opérations dédiées à un produit (ex. DETOX35) ;
    //  2. 2e lettre du code, pour la série historique au format ^[QL][A-Z]P\d{2}$ (F=R6…).
    var code = (currentCode || '').toUpperCase();
    var allow = GIFT_MAP_BY_FP[maFp(code)] || GIFT_MAP[code.charAt(1)] || null; // sinon AUCUN cadeau
    pickers.forEach(function (box) {
      var ul = box.querySelector('.cart-gift__list');
      if (!ul) return; // hint / progression / cadeau déjà choisi -> pas de sélection à filtrer
      if (!allow) {
        // Aucun code d'opération (panier nu ou code natif seul) : on masque toute la
        // sélection — pas d'offre cadeau sans code avantage. Inline pour battre `:has()`.
        box.style.display = 'none';
        return;
      }
      box.style.display = '';
      ul.querySelectorAll('[data-gift-sku]').forEach(function (li) {
        var sku = (li.getAttribute('data-gift-sku') || '').toUpperCase();
        li.hidden = allow.indexOf(sku) === -1;
      });
    });
  }

  // PLAFOND 5 UNITÉS (offre Type 2) — bloque visuellement le compteur : max=5 sur
  // l'input et bouton « + » désactivé à 5. S'applique aux sélecteurs de quantité
  // (fiche produit ET panier). Réappliqué au ré-rendu via l'observer/les événements.
  function applyQtyCap() {
    var type2 = isType2(currentCode);
    document.querySelectorAll('.quantity-selector').forEach(function (comp) {
      var input = comp.querySelector('input[type="number"]');
      if (!input) return;
      var plus = comp.querySelector('button[name="plus"]');
      if (type2 && !qtySelectorIsExcluded(comp)) {
        input.setAttribute('max', String(MAX_TYPE2));
        input.dataset.maCap = '1';
        if (plus) plus.disabled = (parseInt(input.value, 10) || 0) >= MAX_TYPE2;
      } else if (input.dataset.maCap) {
        input.removeAttribute('max');
        delete input.dataset.maCap;
        if (plus) plus.disabled = false;
      }
    });
  }

  // Filet de sécurité : si une ligne payante dépasse 5 unités alors qu'un code Type 2
  // est actif, on ramène sa quantité à 5 (peu importe comment on y est arrivé).
  // Les réfs de NO_UNIT_PRICE_SKUS en sont dispensées : elles restent au prix de lot,
  // donc rien ne justifie de limiter la quantité commandée.
  // Renvoie true si un ajustement a été déclenché (un cart:update suivra).
  function clampType2(cart) {
    if (!isType2(currentCode) || !cart || !cart.items || !cart.items.length) return false;
    var changed = false;
    var updates = cart.items.map(function (it) {
      if (!isGiftItem(it) && !isExcludedFromType2(it) && it.quantity > MAX_TYPE2) {
        changed = true;
        return MAX_TYPE2;
      }
      return it.quantity;
    });
    if (!changed) return false;
    fetch(UPDATE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates, sections: [] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        maNotice('Offre à 5 € : 5 unités maximum par référence — les quantités ont été ajustées.');
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: {} } }));
      })
      .catch(function () {});
    return true;
  }

  // Petit bandeau d'information éphémère (bas de page).
  var noticeEl = null, noticeTimer = null;
  function maNotice(text) {
    if (!noticeEl) {
      noticeEl = document.createElement('div');
      noticeEl.className = 'ma-notice';
      noticeEl.setAttribute('role', 'status');
      document.body.appendChild(noticeEl);
    }
    noticeEl.textContent = text;
    noticeEl.classList.add('is-visible');
    clearTimeout(noticeTimer);
    noticeTimer = setTimeout(function () { noticeEl.classList.remove('is-visible'); }, 4500);
  }

  function applyDomRules() { applyGiftFilter(); applyQtyCap(); }

  var raf = null;
  function scheduleFilter() {
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = null; applyDomRules(); });
  }

  // ---------------------------------------------------------------------------
  // UI « code avantage » (fiche + bandeau, tous les [data-ma-code] de la page)
  // ---------------------------------------------------------------------------
  // Liste des codes à AFFICHER comme actifs : le code d'OPÉRATION (currentCode, qui pilote
  // seul les cadeaux / le plafond / le type) suivi des codes NATIFS que Shopify confirme
  // `applicable:true` dans le panier (ex. BIENVENUE10). Les natifs ne sont jamais optimistes :
  // ils n'apparaissent que si le serveur les valide.
  function displayList(cart) {
    var out = [], seen = {};
    if (currentCode) { out.push(currentCode); seen[currentCode] = 1; }
    (((cart && cart.discount_codes) || [])).forEach(function (d) {
      var c = (d.code || '').toUpperCase();
      if (!c || seen[c] || isValidCodeFormat(c)) return; // opération déjà gérée via currentCode
      if (d.applicable) { out.push(c); seen[c] = 1; }
    });
    return out;
  }

  // Construit une pastille « ✓ CODE ✕ » (en DOM, pas d'innerHTML -> aucune injection possible).
  // Le ✕ porte son propre code (data-code) : la délégation d'événements retire CE code précis.
  function makeChip(box, code) {
    var isBar = box.hasAttribute('data-ma-codebar');
    var chip = document.createElement('span');
    chip.className = isBar ? 'ma-codebar__chip' : 'ma-code__chip';
    if (isBar) {
      var chk = document.createElement('span');
      chk.className = 'ma-codebar__chip-check';
      chk.setAttribute('aria-hidden', 'true');
      chk.textContent = '✓';
      chip.appendChild(chk);
    }
    var strong = document.createElement('strong');
    strong.textContent = code;
    chip.appendChild(strong);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = isBar ? 'ma-codebar__remove' : 'ma-code__remove';
    btn.setAttribute('data-ma-code-remove', '');
    btn.setAttribute('data-code', code);
    btn.setAttribute('aria-label', 'Retirer le code ' + code);
    btn.setAttribute('title', 'Retirer ' + code);
    btn.textContent = '✕';
    chip.appendChild(btn);
    return chip;
  }

  // `codes` = tableau des codes à afficher (peut être vide). Chaque code = une pastille avec
  // son propre ✕ ; la note « 5 max/réf » suit l'offre à 5 € (pilotée par l'opération active).
  function updateCodeBlocks(codes) {
    var list = codes || [];
    var has = list.length > 0;
    document.querySelectorAll('[data-ma-code]').forEach(function (box) {
      var status = box.querySelector('[data-ma-code-status]');
      var listEl = box.querySelector('[data-ma-code-list]');
      var errEl = box.querySelector('[data-ma-code-err]');
      var note = box.querySelector('[data-ma-code-note]');
      if (listEl) {
        listEl.textContent = ''; // reset
        if (has) list.forEach(function (c) { listEl.appendChild(makeChip(box, c)); });
      }
      if (has) {
        if (status) status.hidden = false;
        if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
        if (note) note.hidden = !isType2(currentCode); // rappel « 5 max/réf » pour l'offre à 5 €
        box.classList.add('is-active');
      } else {
        if (status) status.hidden = true;
        if (note) note.hidden = true;
        box.classList.remove('is-active');
      }
    });
  }

  function showError(box, message) {
    var errEl = box && box.querySelector('[data-ma-code-err]');
    if (!errEl) return;
    errEl.textContent = message;
    errEl.hidden = false;
  }

  // ---------------------------------------------------------------------------
  // Lecture de l'état réel : une seule requête /cart.js -> code actif + filtre.
  // ---------------------------------------------------------------------------
  function refresh() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // CODE D'OPÉRATION (pilote cadeaux/plafond/type) = 1er code présent au format opération.
        // Présence suffit (ne PAS filtrer sur `applicable` : une remise Function peut être
        // valide sans encore réduire le panier).
        var op = (((cart && cart.discount_codes) || [])
          .map(function (d) { return (d.code || '').toUpperCase(); })
          .filter(function (c) { return isValidCodeFormat(c); }))[0];
        if (op) {
          currentCode = op;
          storeCode(currentCode);
        } else if (cart && cart.item_count > 0) {
          // Panier non vide sans code d'opération -> plus d'opération active.
          currentCode = '';
          forgetCode();
        } else {
          // Panier vide : Shopify ne conserve pas le code -> on se fie à la mémoire locale.
          currentCode = fromLocal();
        }
        // Nettoyage : une saisie invalide restée en mémoire (ancien bug) ne doit pas
        // réapparaître comme opération active.
        if (currentCode && !isValidCodeFormat(currentCode)) { currentCode = ''; forgetCode(); }
        updateCodeBlocks(displayList(cart)); // opération + codes natifs applicables
        if (clampType2(cart)) return; // un ajustement relancera refresh via cart:update
        applyDomRules();
      })
      .catch(function () {
        currentCode = fromLocal() || fromDom();
        if (currentCode && !isValidCodeFormat(currentCode)) { currentCode = ''; forgetCode(); }
        updateCodeBlocks(currentCode ? [currentCode] : []); // hors ligne : opération seule
        applyDomRules();
      });
  }

  // ---------------------------------------------------------------------------
  // Appliquer un code (remplace l'actuel) — depuis la fiche ou le bandeau.
  // ---------------------------------------------------------------------------
  function applyCode(rawCode, box) {
    var code = (rawCode || '').trim();
    if (!code) return;
    var up = code.toUpperCase();

    // `box` peut être absente : l'auto-application depuis l'URL (?ma_code=) intervient
    // aussi sur des pages qui n'affichent pas le bloc « Code avantage ».
    var form = box && box.querySelector('[data-ma-code-form]');
    var input = form && form.querySelector('[name="ma_code"]');
    var btn = form && form.querySelector('button[type="submit"]');

    // Vérif LISTE BLANCHE (asynchrone : hachage SHA-256). Un code au FORMAT opération n'est
    // accepté que si son empreinte figure dans window.MA_ACTIVE_CODES ; sinon refus local
    // immédiat (expiré/inexistant), sans interroger Shopify. Les codes NATIFS (ex. BIENVENUE10)
    // ne matchent pas le format -> ils sautent la vérif et sont validés à la réponse Shopify.
    (isValidCodeFormat(up) ? isKnownOpCode(up) : Promise.resolve(true)).then(function (known) {
      if (!known) {
        showError(box, 'Code invalide ou périmé. Vérifiez la saisie.');
        if (input) { input.value = ''; input.focus(); }
        return;
      }
      proceed();
    });

    function proceed() {
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = '…'; }
    function done() { if (btn) { btn.disabled = false; btn.textContent = label; } }

    // CUMUL : on lit d'abord le panier pour conserver les codes PONCTUELS déjà
    // présents (ex. BIENVENUE10, remise d'ordre) et remplacer tout code d'OPÉRATION
    // précédent (un seul code d'opération à la fois). Offre 2 (prix unique 5 €) =
    // exclusive : on repart de zéro. Le cumul effectif dépend aussi des réglages
    // « Combinaisons » Shopify (offre 1 = combinesWith.orderDiscounts:true, cf. app).
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return {}; })
      .then(function (cart) {
        var existing = (((cart && cart.discount_codes) || [])
          .filter(function (d) { return d.applicable; })
          .map(function (d) { return d.code; }));
        var keep;
        if (isType2(up)) {
          keep = [];                                                    // Offre 2 : exclusive
        } else if (isValidCodeFormat(up)) {
          // Offre 1 (opération) : remplacer l'ancienne opération, garder les codes natifs.
          keep = existing.filter(function (c) { return !isValidCodeFormat(c); });
        } else {
          // Code NATIF : conserver l'opération active ET les autres natifs ; éviter son doublon.
          keep = existing.filter(function (c) { return c.toUpperCase() !== up; });
        }
        var newSet = keep.concat(up);
        return fetch(UPDATE_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: newSet.join(','), sections: [] })
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var itemCount = (data && data.item_count) || 0;
        var isOp = isValidCodeFormat(up);
        var found = (((data && data.discount_codes) || []).filter(function (d) {
          return d.code && d.code.toUpperCase() === up;
        })[0]);

        // ACCEPTATION :
        //  - OPÉRATION : optimiste. Présent dans la réponse OU panier vide (invalidable côté
        //    serveur -> s'appliquera dès l'ajout d'articles).
        //  - NATIF (ex. BIENVENUE10) : seulement si Shopify le confirme `applicable:true`.
        //    Shopify renvoie aussi les fautes de frappe (applicable:false) -> c'est le filtre.
        var accepted = isOp
          ? (!!found || itemCount === 0)
          : (!!found && found.applicable === true);

        // CONFLIT DE CUMUL : un AUTRE code déjà appliqué qui empêche celui-ci de passer.
        // Deux familles bloquent un code natif (= remise de COMMANDE) :
        //  - un autre code NATIF : deux remises « commande » ne se combinent que si les DEUX
        //    l'autorisent -> en pratique exclusives entre elles ;
        //  - une offre d'opération configurée SANS cumul avec les remises de commande : les
        //    offres de TYPE 2 (5 €/produit) le sont par construction, et certains codes
        //    dédiés le sont par réglage admin (NO_ORDER_CUMUL_FPS). Le cumul Shopify étant
        //    BILATÉRAL, elles rejettent le code natif.
        // Les opérations qui acceptent les remises de commande (grille de lots QIP05,
        // LIP10…) ne bloquent rien et ne doivent JAMAIS être accusées, sinon on enverrait le
        // client retirer un code parfaitement innocent.
        //
        // Corrigé le 2026-08-18 : le filtre excluait tous les codes d'opération, si bien que
        // le cas le plus fréquent en pratique — un QIP50 encore actif dans le panier (souvent
        // réappliqué tout seul par le cookie `discount_code` d'un ancien lien) — tombait dans
        // le message générique « Code invalide ou périmé » et envoyait chercher une faute de
        // frappe inexistante.
        var conflit = (((data && data.discount_codes) || []).filter(function (d) {
          var c = (d.code || '').toUpperCase();
          if (!d.applicable || c === up) return false;
          return !isValidCodeFormat(c) || isType2(c) || NO_ORDER_CUMUL_FPS.indexOf(maFp(c)) !== -1;
        })[0]);

        if (!accepted) {
          // Option A : panier vide + code natif = non validable -> inviter à ajouter un article
          // plutôt que d'afficher à tort un code (potentiellement erroné) comme actif.
          if (!isOp && itemCount === 0) {
            showError(box, 'Ajoutez un article à votre panier pour activer ce code.');
          } else if (!isOp && conflit) {
            // Shopify renvoie `applicable:false` aussi bien pour une faute de frappe que pour un
            // refus de cumul : indiscernable sans re-soumettre le code seul (2 requêtes de plus
            // + panier à restaurer si l'une échoue). On privilégie le cas de loin le plus
            // fréquent — code correct + offre non cumulable déjà au panier — et on nomme le
            // coupable, avec le geste exact qui débloque la situation.
            // Formulation sans symbole : le « (✕) » renvoyait à la croix de la pastille,
            // peu lisible pour le public de la marque. On nomme le geste en toutes lettres.
            showError(box, 'Vous bénéficiez déjà du code « ' + conflit.code + ' ». '
              + 'Ces deux réductions ne se cumulent pas : retirez le code actif en cliquant '
              + 'sur la croix, puis saisissez à nouveau le code souhaité.');
          } else {
            showError(box, 'Code invalide ou périmé. Vérifiez la saisie.');
          }
          if (input) { input.value = ''; input.focus(); }
          done();
          return;
        }

        if (input) input.value = '';
        // Seul un code d'opération devient le currentCode (pilote cadeaux/plafond) ; un code
        // natif s'ajoute à l'affichage sans toucher l'opération active.
        if (isOp) { currentCode = up; storeCode(up); }
        updateCodeBlocks(displayList(data));
        // Prévenir les cartes de lots de se reconstruire sans rechargement.
        document.dispatchEvent(new CustomEvent('ma:code-applied', { bubbles: true }));
        if (data && data.item_count > 0) {
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: {} } }));
        }
        applyDomRules();
        done();
      })
      .catch(function () {
        // Repli réseau : lien d'application natif (rechargement de page).
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(location.pathname);
      });
    }
  }

  // ---------------------------------------------------------------------------
  // Retirer UN code (croix ✕ d'une pastille) — on ne retire que ce code, on garde les autres.
  // Sans argument (repli) : retire les codes d'OPÉRATION, conserve les codes natifs.
  // ---------------------------------------------------------------------------
  function removeCode(targetCode) {
    var target = (targetCode || '').toUpperCase();
    function clearUi() {
      currentCode = '';
      forgetCode();
      updateCodeBlocks([]);
      applyDomRules();
    }
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return {}; })
      .then(function (cart) {
        var applicable = (((cart && cart.discount_codes) || [])
          .filter(function (d) { return d.applicable; })
          .map(function (d) { return d.code; }));
        var next = target
          ? applicable.filter(function (c) { return c.toUpperCase() !== target; })
          : applicable.filter(function (c) { return !isValidCodeFormat(c); }); // repli : opérations
        return fetch(UPDATE_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: next.join(','), sections: [] })
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        // Si le code retiré était l'opération active (ou repli sans cible), on remet
        // l'état d'opération à zéro (cadeaux/plafond). Un code natif retiré n'y touche pas.
        if (!target || (isValidCodeFormat(target) && target === (currentCode || '').toUpperCase())) {
          currentCode = '';
          forgetCode();
        }
        updateCodeBlocks(displayList(data)); // reste : opération + natifs encore applicables
        applyDomRules();
        // Les cartes de lots se reconstruisent selon l'état d'opération courant.
        document.dispatchEvent(new CustomEvent('ma:code-applied', { bubbles: true }));
        if (data && data.item_count > 0) {
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: {} } }));
        }
      })
      .catch(clearUi); // hors ligne : au moins nettoyer l'affichage
  }

  // Ouvre le tiroir panier Horizon (avec replis).
  function openCart() {
    var d = document.querySelector('cart-drawer-component');
    if (d && typeof d.open === 'function') { d.open(); return; }
    var trig = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (trig) { trig.click(); return; }
    window.location.href = '/cart';
  }

  // ---------------------------------------------------------------------------
  // Délégation d'événements (survit au ré-rendu des sections)
  // ---------------------------------------------------------------------------
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-ma-code-form]');
    if (!form) return;
    e.preventDefault();
    var box = form.closest('[data-ma-code]');
    var input = form.querySelector('[name="ma_code"]');
    applyCode(input ? input.value : '', box);
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var rm = e.target.closest('[data-ma-code-remove]');
    if (rm) { e.preventDefault(); removeCode(rm.getAttribute('data-code') || ''); return; }
    if (e.target.closest('[data-ma-code-cart]')) { e.preventDefault(); openCart(); return; }
  });

  // Saisie/clic sur un compteur de quantité -> réactualiser l'état du bouton « + ».
  document.addEventListener('input', function (e) {
    if (e.target && e.target.matches && e.target.matches('.quantity-selector input[type="number"]')) applyQtyCap();
  });

  document.addEventListener('cart:update', refresh);
  document.addEventListener('ma:code-applied', refresh);
  window.addEventListener('storage', function (e) {
    if (e.key === 'ma_code_value' || e.key === 'ma_code_active') {
      currentCode = fromLocal();
      updateCodeBlocks(currentCode ? [currentCode] : []);
      scheduleFilter();
    }
  });

  // ---------------------------------------------------------------------------
  // AUTO-APPLICATION DEPUIS L'URL — `?ma_code=QIP50`
  // ---------------------------------------------------------------------------
  // Posé par les liens des emailings : le client clique, le code est saisi POUR lui.
  // Sans ça, `/discount/{CODE}` (cookie Shopify) donne bien la remise au paiement, mais
  // le thème n'en sait rien tant que le panier est vide -> la fiche produit continue
  // d'afficher le prix unitaire et réclame le code. Les liens des emails posent donc les
  // DEUX : /discount/... pour Shopify, ?ma_code=... pour l'affichage.
  //
  // Aucun contournement possible : on passe par le même applyCode() que la saisie manuelle,
  // donc par le même contrôle de format + liste blanche d'empreintes. Un code périmé
  // collé dans une URL est refusé exactement comme s'il était tapé.
  function applyCodeFromUrl() {
    var m = /[?&]ma_code=([^&#]*)/.exec(window.location.search || '');
    if (!m) return;

    // Le paramètre ne doit pas survivre : ni dans un lien re-partagé, ni dans l'historique,
    // ni dans les URL que les outils d'analyse enregistrent. On le retire tout de suite,
    // que le code soit finalement accepté ou non.
    var code = '';
    try { code = decodeURIComponent(m[1] || '').trim().toUpperCase(); } catch (e) { code = ''; }
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete('ma_code');
      history.replaceState(null, '', url.pathname + url.search + url.hash);
    } catch (e) {}

    if (!code) return;
    if (code === fromLocal()) return; // déjà actif : inutile de refaire un aller-retour panier
    applyCode(code, document.querySelector('[data-ma-code]')); // box absente = toléré
  }

  function boot() {
    applyCodeFromUrl();
    refresh();
    // Le drawer panier est ré-injecté (section-rendering) -> ré-applique le filtre quand le DOM bouge.
    try {
      new MutationObserver(scheduleFilter).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
